"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14286],{

/***/ 14286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Duck_DuckWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./UI/components/Duck/utils/helpers.js
var helpers = __webpack_require__(60982);
// EXTERNAL MODULE: ./utils/appContext.js
var appContext = __webpack_require__(16515);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Duck/DuckWrapper/utils/useDuckWrapper.js




var useDuckWrapper = function(param) {
    var sloganRef = param.sloganRef;
    var ref = (0,react.useContext)(appContext/* AppContext */.I), duck = ref.contextData.duck;
    (0,react.useEffect)(function() {
        if (!duck) {
            return;
        }
        var isMobile = window.innerWidth < helper/* mobileResolution */.re;
        helpers/* slogan.animateSlogan */.y.animateSlogan(sloganRef);
        helpers/* slogan.sloganOpacityAnimation */.y.sloganOpacityAnimation(!isMobile ? 0.1 : 1);
    }, [
        duck,
        sloganRef
    ]);
    return {
        duck: duck,
        sloganRef: sloganRef
    };
};

;// CONCATENATED MODULE: ./UI/components/Duck/DuckWrapper/index.jsx



var Duck = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 67762).then(__webpack_require__.bind(__webpack_require__, 67762));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67762)
            ];
        }
    },
    ssr: false
});
var DuckWrapper = function(props) {
    var ref = useDuckWrapper(props), duck = ref.duck, sloganRef = ref.sloganRef;
    return duck && /*#__PURE__*/ (0,jsx_runtime.jsx)(Duck, {
        sloganRef: sloganRef,
        duck: duck
    });
};
/* harmony default export */ var Duck_DuckWrapper = (DuckWrapper);


/***/ })

}]);